module.exports = __webpack_public_path__ + "img/en.bd1aa534.svg";